import Vue from "vue";
import Vuetify from "vuetify/lib";
import { de } from "vuetify/src/locale";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#8b1a1a"
      }
    }
  },
  lang: {
    current: "de",
    locales: { de }
  }
});
